import React, { Component, useState, createRef } from 'react';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Clear from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import DirectionsIcon from '@material-ui/icons/Directions';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import { withMultiLanguagesConsumer } from "../../contexts/messages";

const btnTheme = createMuiTheme({
    palette: {
        primary: {
            main: "#FCB602",
        },
        secondary: {
            main: "#42647A"
        },
        login: {
            main: "#FCB602"
        }
    },
});

const styles = theme => ({
    textBtn: {
        margin: theme.spacing.unit,
    },
    closed: {
        maxHeight: 0,
        overflow: 'hidden'
    },
    searchRoot: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        // width: 400,
        // margin: 40
    },
    input: {
        marginLeft: 8,
        flex: 1,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        width: 1,
        height: 28,
        margin: 4,
    },
    deleteWarning: {
        width: 500,
        height: 300,
        display: "flex",
        justifyContent: "space-around",
        flexDirection: "column",
        textAlign: "center"
    },
    warningBtns: {
        display: "flex",
        flexDirection: "row",
        width: 250,
        justifyContent: "space-between",
        margin: "0 auto"
    },
    confirmMessage: {

    },
    message: {
        margin: "0 40px"
    },
    button: {
        width: '100%',
        height: 48,
        marginBottom: 30
    }
})

export const Btn = (props) => (
    <MuiThemeProvider theme={btnTheme}>
        <Button {...props}>
            {props.children}
        </Button>
    </MuiThemeProvider>
)

export const AuthBtn = withStyles(styles)((props) => (
    <Btn className={props.classes.button} {...props} />
))

export const TextBtn = withStyles(styles)((props) => (
    <MuiThemeProvider theme={btnTheme}>
        <Button {...props}
                className={props.classes.TextBtn}>
            {props.children}
        </Button>
    </MuiThemeProvider>
))

export const Collapse = withStyles(styles)((props) => {
    const [open, toggleTo] = useState(false);
    return (
        <div>
            <div onClick={() => toggleTo(!open)}>
                {props.title}
            </div>
            <div className={open ? null : props.classes.closed}>
                {props.content}
            </div>
        </div>
    );
})

export const Search = withStyles(styles)((props) => {
    let anchor = React.createRef();
    const [keyword, setKeyword] = useState(props.defaultValue || "");
    function onClick() {
        if (props.onSearch) {
            props.onSearch(keyword);
        }
    }
    function onChange(ev) {
        ev.stopPropagation()
        if (props.onChange) {
            props.onChange(ev);
        }
        setKeyword(ev.target.value)
    }
    function keyDownHandler(e) { 
        e.stopPropagation()
        if (e.keyCode == 13 &&  props.onSearch) {
            props.onSearch(keyword);
        }
    }
    // function onClear() {
    //     setKeyword("");
        
    //     if (props.onClear) {
    //         props.onClear();
    //     }
        
    // }
    return (
        <Paper className={props.classes.searchRoot} style={props.customStyles ? props.customStyles.root : null}>
            <InputBase className={props.classes.input}
                 autoFocus={props.autoFocus}
                 onChange={onChange}
                 ref={anchor}
                 onKeyDown={keyDownHandler}
                 classes={props.inputStyles}
                 defaultValue={props.defaultValue}
                 placeholder={props.placeholder}
                />
            {
                !props.searchIcon ? null :
                <IconButton aria-label="Search" onClick={onClick}>
                    <SearchIcon />
                </IconButton>
            }
            {/* <Divider />
            <IconButton aria-label="Search" onClick={onClear}>
                <Clear />
            </IconButton> */}
        </Paper>
    );
})

export const Warning = withMultiLanguagesConsumer(withStyles(styles)((props) => {
    const { 
        classes,
        open,
        onClose,
        message,
        confirmMessage,
        actionBtnColor,
        actionName,
        onClickAction,
        cancelName
    } = props;
    const {
        CANCEL, CONFIRM
    } = props.messagePool;
    const [confirm, setConfirm] = useState("");
    return (
        <Dialog open={open} onClose={onClose}>
            <div className={classes.deleteWarning} >
                <div className={classes.message}>
                    {message}
                    { confirmMessage && confirmMessage.length > 0 ? " Please type the word below to confirm." : ""}
                </div>

                {confirmMessage && confirmMessage.length > 0 ? 
                    <div className={classes.confirmMessage}>
                        <TextField 
                            label={confirmMessage} 
                            // variant="outlined"
                            inputProps={{style: {"padding-left": '10px'}}}
                            size="small"
                            onChange={(event) => {
                                setConfirm(event.target.value);
                            }}
                        />
                    </div>: null
                }
                <div className={classes.warningBtns}>
                    <Btn variant="contained" 
                        color={actionBtnColor ? actionBtnColor : "primary"}
                        // className={classes.button}
                        onClick={async () => { 
                            await onClickAction();
                            onClose();
                        }}
                        disabled={confirmMessage && confirm != confirmMessage}
                    >
                        {actionName ? actionName : CONFIRM}
                    </Btn>
                    <Btn variant="contained" 
                        color="default"
                        // className={classes.button}
                        onClick={onClose}
                    >
                        {cancelName ? cancelName : CANCEL}
                    </Btn>
                </div>
            </div>
        </Dialog>
    )
}))

export const CustomizedTooltip = withStyles((theme) => ({
    tooltip: {
        fontSize: 14
    },
}))(Tooltip); 

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
}))(Tooltip);


export const SortArrow = withStyles((theme) => ({

}))((props) => (
    <div>
        <ArrowDropDownIcon />
        <ArrowDropUpIcon />
    </div>
))